import type { PartnerFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

// Returns the first two partners if co-branding is enabled.
const getPartnersForSpecialization = (partners?: Array<PartnerFragment> | null, isCoBrandingEnabled?: boolean) => {
  if (isCoBrandingEnabled && partners && partners.length > 1) {
    return partners?.slice(0, 2);
  } else {
    return partners?.slice(0, 1);
  }
};

export default getPartnersForSpecialization;
